// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__11KFD","footer":"ReportModalFilter_footer__1hJkO"};